import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { rolloutRefetchInterval } from "./catalogueDeployments";
import { Exercise } from "../views/exercises/types";

const useGetExercise = (exercise_id?: number) =>
  useQuery<Exercise>(
    queryKeys.exercise(exercise_id ?? 0),
    () =>
      // @ts-ignore
      api.parse(`GET /exercises/${exercise_id}`, {
        root: supportApiBase,
      }),
    {
      enabled: !!exercise_id,
      refetchInterval: data => rolloutRefetchInterval(data ? [data] : undefined),
    }
  );

export default useGetExercise;
